/* unplugin-vue-components disabled */import script from "./role.vue?vue&type=script&setup=true&lang=ts"
export * from "./role.vue?vue&type=script&setup=true&lang=ts"

import "./role.vue?vue&type=style&index=0&id=f9dc5340&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9dc5340"]])

export default __exports__